// Mejora fichas (21-oct-2026) — Aviso de nombre repetido al guardar: «¿Es la misma persona?».
// Nunca fusiona sola: «Sí, es el mismo» suma el teléfono/correo a la ficha existente; «No, es otra persona» crea la nueva.
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { UserCheck, UserPlus } from 'lucide-react';
import { tr } from '@/contexts/LanguageContext';

export const isNameDuplicateError = (err) => err?.status === 409 && err?.code === 'name_duplicate';

export const contactLabel = (c) => [c.phone_masked ? `${tr("teléfono")} ${c.phone_masked}` : null, c.email_masked ? `${tr("correo")} ${c.email_masked}` : null].filter(Boolean).join(' / ') || tr("sin contacto");

export const DuplicateAskDialog = ({ open, duplicates = [], busy = false, onSame, onDifferent, onCancel }) => (
  <Dialog open={open} onOpenChange={(o) => !o && !busy && onCancel?.()}>
    <DialogContent className="max-w-md" data-testid="dup-ask-dialog">
      <DialogHeader>
        <DialogTitle className="font-display">{tr("¿Es la misma persona?")}</DialogTitle>
        <DialogDescription data-testid="dup-ask-text">
          {duplicates[0] && tr("Ya tienes un cliente llamado {0} ({1}).", duplicates[0].name, contactLabel(duplicates[0]))}
          {' '}{tr("Si es la misma persona, el teléfono o correo nuevo se añade a su ficha. Nunca se fusiona sin tu confirmación.")}
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-2">
        {duplicates.map((c) => (
          <div key={c.id} className="flex items-center justify-between gap-2 rounded-xl border border-border bg-background px-3 py-2" data-testid={`dup-ask-row-${c.id}`}>
            <div className="min-w-0">
              <p className="text-sm font-semibold truncate">{c.name}</p>
              <p className="text-[11px] text-muted-foreground truncate">{contactLabel(c)} · {c.bookings_count} {tr("citas")}{c.has_account ? ` · ${tr("con cuenta")}` : ''}</p>
            </div>
            <Button size="sm" className="rounded-full gap-1 flex-shrink-0" disabled={busy} onClick={() => onSame(c)} data-testid={`dup-ask-same-${c.id}`}>
              <UserCheck className="w-3.5 h-3.5" />{duplicates.length > 1 ? tr("Sí, es este") : tr("Sí, es el mismo")}
            </Button>
          </div>
        ))}
        <Button variant="outline" className="w-full rounded-full gap-1" disabled={busy} onClick={onDifferent} data-testid="dup-ask-different">
          <UserPlus className="w-3.5 h-3.5" />{tr("No, es otra persona")}
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);

export default DuplicateAskDialog;
